import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const createThread = async () => {
   return axios({
      method: "post",
      url: `${hostCloud}/assistant/create-thread`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json"
      }
   });
};

export const getAiResponse = async (assistantId, messageId, threadId, userCommand) => {
   const data = {
      assistantId: assistantId,
      threadId: threadId,
      userCommand: userCommand,
      messageId: messageId
   };
   return axios({
      method: "post",
      url: `${hostCloud}/assistant/add-message-and-get-response`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json"
      },
      data: JSON.stringify(data)
   });
};
